import './FieldError.scss';

interface FieldErrorProps {
    /** Se referencia desde el campo con `aria-describedby`. */
    id: string;
    message?: string | null;
}

/**
 * Leyenda del marcador de error de un campo (design system §3.8.1).
 * El campo lleva `aria-invalid`, `aria-describedby={id}` y la clase `field-error-target`.
 */
export default function FieldError({ id, message }: FieldErrorProps) {
    if (!message) return null;

    return (
        <small id={id} className="field-error">
            <i className="pi pi-exclamation-triangle" aria-hidden="true" />
            {message}
        </small>
    );
}
